module.exports = __webpack_public_path__ + "img/138.01771553.png";